import { BASE_URL } from "../config/config";
import { getUserCountry } from "./LocationService";

export const fetchTopChannels = async () => {
    try {
        // Get User Location (Country Code)
        const userCountryCode = await getUserCountry();

        console.log("User Country Code:", userCountryCode); // Debugging output

        // Fetch Radio Channels Based on Country Code
        const response = await fetch(`${BASE_URL}/top-channels`);
        if (!response.ok) {
            throw new Error("Network response was not ok");
        }

        const data = await response.json();
        return data;
    } catch (error) {
        console.error("Error fetching Radio Channels:", error);
        throw error;
    }
};

export const fetchMostLikedChannels = async () => {
    try {
        // Get User Location (Country Code)
        const userCountryCode = await getUserCountry();

        console.log("User Country Code:", userCountryCode); // Debugging output

        // Fetch Radio Channels Based on Country Code
        const response = await fetch(`${BASE_URL}/most-liked-channels`);
        if (!response.ok) {
            throw new Error("Network response was not ok");
        }

        const data = await response.json();
        return data;
    } catch (error) {
        console.error("Error fetching Radio Channels:", error);
        throw error;
    }
};

export const fetchMostFavoriteChannels = async () => {
    try {
        // Get User Location (Country Code)
        const userCountryCode = await getUserCountry();

        console.log("User Country Code:", userCountryCode); // Debugging output

        // Fetch Radio Channels Based on Country Code
        const response = await fetch(`${BASE_URL}/most-favorite-channels`);
        if (!response.ok) {
            throw new Error("Network response was not ok");
        }

        const data = await response.json();
        return data;
    } catch (error) {
        console.error("Error fetching Radio Channels:", error);
        throw error;
    }
};